import { Dispatch } from 'redux';
import fetchApi from '../services/api';
import * as types from './actionTypes';
import { parseNumber } from '../lib/helpers';

/**
 * Get Closing Costs
 * @param {string} homePrice - A listing's price
 * @param {number} percentDown - Precentage downPayment
 * @param {string} token - A user's authentication token
 */
export function getClosingCosts(
  homePrice: string,
  percentDown: number,
  state: string,
  token?: string,
) {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: types.ClosingCostsFetch });
    const parsedHomePrice = parseInt(parseNumber(homePrice), 10);
    try {
      const response = await fetchApi(
        `/closing-costs`,
        { homePrice: parsedHomePrice, percentDown, state },
        'post',
        {},
        token,
      );
      const json = await response.json();
      if (response.ok) {
        dispatch({
          closingCostState: state,
          prepaidInfo: json.prepaidInfo,
          toriiBrokerage: json.toriiBrokerage,
          traditionalBrokerage: json.traditionalBrokerage,
          type: types.ClosingCostsFetchSuccess,
        });
      } else {
        dispatch({
          type: types.ClosingCostsFetchFailure,
        });
      }
    } catch (error) {
      dispatch({
        error,
        type: types.GenericError,
      });
    }
  };
}
